import React, { useEffect, useRef, useState } from "react";
import { SVGAsset } from "res";

import "./styles.css";
const UIDropdownButtonContext = React.createContext(null);
/**
 * @function UIDropdownButton
 * @param {STRING} text - Sets the text for the main button. 
 * @param {FUNCTION} onClick - Allows us to set an event handler on click to open the dropdown content.
 * @param {React.Component} children - Allows us to add React components to the dropdown.
 * @param {STRING} dataPoint - Sets the dataPoint for the UIDropdownButton.
 * @description This is the main button that opens the dropdown.
 * @returns {React.Component}
 * @exported true
 * @example
 * <UIDropdownButton text="Main Text">
 *  <UIDropdownContent>
 *    <UIDropdownContentItem text="Item 1" />
 *  </UIDropdownContent>
 * </UIDropdownButton>
 */
export default function UIDropdownButton(props) {
  const text = props.text ?? "[button text]";
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
  const [isActive, setActive] = useState(false);
  const [value, setValue] = useState(props.value);
  const controller = {
    //compares the value of the item and existing items from prop.children to see which one to pass to selected Item. 
    "selectItem": (item, value) => {
        setValue(value)
        setActive(false)
        if (props.onChange instanceof Function) {
            props.onChange(value);
        }
    },
    "value": () => value,
    "toggle": () => { setActive(!isActive); },
    "close": () => setActive(false),
    "open": () => setActive(true)
};

const cheveron = props.cheveron ?? <SVGAsset id="DownChevronIcon" className="set-width right-icon blue-icon" />;
  return (<>
    <UIDropdownButtonContext.Provider value={controller}>
    <div className="clickable ui-dropdown-button" onClick={props.onClick} {...dataPoint}>
      <div className="button-container flex-container flex-horizontal align-center" onClick={controller.toggle}>
        <span className="flex-width">{ text }</span>
        {cheveron}
      </div>
 {    isActive &&  <UIDropdownContent>
        {  props.children }
      </UIDropdownContent>
}   
    </div>
    </UIDropdownButtonContext.Provider>
    {isActive && <div className="custom-select-overlay" onClick={controller.close}></div>}
    </>
  );
}
export const useUIDropdownButton = () => React.useContext(UIDropdownButtonContext);
/**
 * @function UIDropdownContent
 * @param {React.Component} children - Allows us to add React components to the dropdown.
 * @description This is the dropdown container to hold all the UIDropdownContentItems.
 * @returns {React.Component}
 * @exported true
 * @example
 * <UIDropdownButton text="Main Text">
 *  <UIDropdownContent>
 *    <UIDropdownContentItem text="Item 1" />
 *  </UIDropdownContent>
 * </UIDropdownButton>
 */
export function UIDropdownContent(props) {
  return (
    <div className="ui-dropdown-content">
      {props.children}
    </div>
  );
}

/**
 * @function UIDropdownContentItem
 * @param {STRING} text - Sets the text of the dropdown content item.
 * @param {FUNCTION} onClick - Allows us to set an onClick function to the item.
 * @param {STRING} dataPoint - Sets the dataPoint for the UIDropdownButton.
 * @description This is the component for a dropdown item in the dropdown.
 * @returns {React.Component}
 * @exported true
 * @example
 * <UIDropdownButton text="Main Text">
 *  <UIDropdownContent>
 *    <UIDropdownContentItem text="Item 1" />
 *  </UIDropdownContent>
 * </UIDropdownButton>
 */
export function UIDropdownContentItem(props) {
  const text = props.text ?? "[item text]";
  const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
  let ref = useRef();
  const controller = useUIDropdownButton();

  const onClick = (evt) => {
   
      if (props.disabled !== true) {
         controller.selectItem(ref.current, props.value ===undefined? text:props.value);
         if (props.onClick instanceof Function) {
          props.onClick(ref.current, props.value ===undefined? text:props.value);
      }
      }
  }
  
  return (
    <div className={`ui-dropdown-item clickable ${props.disabled ? "disabled " : ""} ${(controller.value() === props.value || controller.value()=== text) ? "selected " : "" }`} onClick={onClick} {...dataPoint}  >
      <span className="dropdown-item-text">
        <SVGAsset id="CheckmarkOutlineIcon" className="checkmark-icon left-icon" /> 
        { text }
      </span>
    </div>
  );
}